import PN from "persian-number";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";

import { cn } from "../../utils/utils";

const CustomNumberInput = (props) => {
  const { control, name, label, errors, placeholder, className, disabled, maxValue } = props;

  return (
    <div className={cn(" col-span-2 xl:col-span-1 flex flex-col gap-2 ", className)}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => {
          const handleValueChange = (values) => {
            onChange(PN.convertPeToEn(values.formattedValue));
          };

          return (
            <>
              <label htmlFor={""} className="text-[14px] md:text-[16px]">
                {label}
              </label>
              <NumericFormat
                value={value ? value : ""}
                displayType={"input"}
                thousandSeparator={true}
                onValueChange={handleValueChange}
                disabled={disabled}
                allowNegative={false}
                placeholder={placeholder}
                className="h-[52px] px-4  outline-none rounded-v-md  w-full border-2 border-neutral-20 disabled:bg-neutral-10 disabled:border-none"
                isAllowed={(values) => {
                  const { floatValue } = values;
                  if (floatValue > maxValue) return false;
                  return true;
                }}
              />
            </>
          );
        }}
      />

      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
};

export default CustomNumberInput;
